// extracted by mini-css-extract-plugin
export default {"menu__item":"main-menu_menu__item__eBeDy"};